<template>
	<div class="table_box table_tuen_box" v-if="isShow">
		<el-table :data="fileList" row-key="id" max-height="323">
			<el-table-column width="435" align="left">
				<template slot="header" slot-scope="slot">
					<span>文件</span>
				</template>
				<template slot-scope="scope">
					<icon :type="1" :fileType="scope.row.fileTypeCase" :isTable="true"></icon>
					<div class="fonts">
						<a :title="scope.row.name + '.' + scope.row.fileType" class="hidea">{{ scope.row.name | ellipsis
						}}{{ "." +
		scope.row.fileType
}}</a>
					</div>
				</template>
			</el-table-column>
			<el-table-column width="288" align="left">
				<template slot="header" slot-scope="slot">
					<!-- <i class="size_icon"></i> -->
					<span>大小</span>
				</template>
				<template slot-scope="scope" align="left">
					<span :style="{
						color: scope.row.cause || scope.row.zhError ? '#242F44' : '#242F44'
					}">{{ scope.row.getfilesize }}</span>
				</template>
			</el-table-column>
			<el-table-column width="273" align="left">
				<template slot="header" slot-scope="slot">
					<span>{{allzhSuccessEnd?'结果':'状态'}}</span>
				</template>
				<template slot-scope="scope">
					<div v-if="scope.row.wait">
						<i class="wait_icon"></i>等待上传
					</div>

					<div
						v-if="scope.row.upLoadSuccess && !scope.row.isTurnIng && !scope.row.zhError && !scope.row.zhSuccess">
						<i class="success_icon"></i>
						<span>上传成功</span>
					</div>
					<div v-if="scope.row.isUpLoading && !scope.row.cause && !scope.row.wait">
						<i class="uploading_icon"></i>
						<span>
							上传中
							<span class="slh">...</span>
						</span>
					</div>
					<div v-if="scope.row.isTurnIng && !scope.row.wait">
						<i class="turn_icon"></i>
						<span>
							验证中
							<span class="slh">...</span>
						</span>
					</div>
					<div v-if="scope.row.cause && !scope.row.zhError && !scope.row.zhSuccess">
						<i class="error_icon"></i>
						<span :style="{ color: allzhSuccessEnd ? '#8B97AF' : '#242F44' }">
							上传失败
							<a title="重试" class="retry_icon"
								v-if="!allzhSuccessEnd && !scope.row.isTurnIng && !allisTurnIng"
								@click="onFileAdded(scope.row, 'isReUpload')">
								<!-- <i class="el-icon-refresh-right"></i> -->
								重试
							</a>
						</span>
					</div>
					<div v-if="scope.row.zhSuccess && !scope.row.cause">
						<i class="yz_success_icon"></i>验证有效
					</div>
					<div v-if="scope.row.zhError && scope.row.cause">
						<i class="sx_error" v-if="scope.row.sxShow"></i><i class="djg_error" v-else-if="scope.row.djgShow"></i><i class="noopen_error" v-else-if="scope.row.noopen"></i><i class="wz_error" v-else></i>{{
								scope.row.cause
						}}
					</div>
				</template>
			</el-table-column>
			<el-table-column>
				<template slot="header" slot-scope="slot">
					<!-- <i class="cz_icon"></i> -->
					<span>操作</span>
				</template>
				<template slot-scope="scope">
					<a title="查看详情" v-if="(!allUpLoadIng && !allisTurnIng && scope.row.open) || allzhSuccessEnd"
						class="yq_icon" :class="{ disable: allzhSuccessEnd && !scope.row.open }"
						@click="showItem(scope.row)"></a>
					<a title="预览" v-if="!allUpLoadIng && !allisTurnIng&&allzhSuccessEnd"
						class="open_icon"
						@click="readApi(scope.row.shortUrl)"></a>
					<a title="删除" v-if="!allUpLoadIng && !allisTurnIng" class="delet_icon"
						:class="{ disable: allUpLoadIng || allisTurnIng }" @click="suspendBtn(scope.row)"></a>
				</template>
			</el-table-column>
		</el-table>
		<div class="table_bottom" v-if="showBottom">
			<div class="left">
				<el-popover placement="top-start" width="300" v-model="visible">
					<p style="margin-bottom: 50px">确认将列表中的全部文件删除吗？</p>
					<div style="text-align: right; margin: 0">
						<el-button type="primary" size="mini" class="mini_btn" @click="submitBtn">删除</el-button>
						<el-button size="mini" type class="mini_btn" @click="visible = false">取消</el-button>
					</div>
					<el-button slot="reference" :disabled="allUpLoadIng || allisTurnIng"
						v-if="!allzhSuccessEnd && !allZhError">清空列表</el-button>
				</el-popover>
				<div class="hb_box" :class="{
					disable: allUpLoadIng || allisTurnIng || allzhSuccessEnd || uploadSuccessList.length <= 1
				}" v-if="fileList.length > 1 && !allzhSuccessEnd && uploadSuccessList.length > 1">
				</div>
				<div class="hb_box"
					v-if="!allzhSuccessEnd && !allUpLoadIng && !allisTurnIng && uploadSuccessList.length != fileList.length">
					<i class="tips_icon"></i>
					<span style="color: #e02020">上传失败的文件无法进行验证</span>
				</div>
				<div class="hb_box list_box" v-if="allzhSuccessEnd">
					<span class="list_item1" :class="{ active1: activeChoose == 1 }" @click="chooseClick(1)">总验证<span
							style="color: #14A8F0;text-decoration: underline;">{{
									zhSuccessList.length
							}}</span>个文件</span>
					<span style="color: #D7D9DF" v-if="downzhSuccessList.length > 0">|</span> <span
						v-if="downzhSuccessList.length > 0" class="list_item2" :class="{ active2: activeChoose == 2 }"
						@click="chooseClick(2)">验证有效<span style="color: #3FC857;text-decoration: underline;">{{
								downzhSuccessList.length
						}}</span>个文件</span>
					<span style="color: #D7D9DF" v-if="zhSuccessList.length - downzhSuccessList.length > 0">|</span>
					<span v-if="zhSuccessList.length - downzhSuccessList.length > 0" class="list_item3"
						:class="{ active3: activeChoose == 3 }" @click="chooseClick(3)">其他<span
							style="color: #FFAA00;text-decoration: underline;">{{
									zhSuccessList.length -
									downzhSuccessList.length
							}}</span>个文件</span>
				</div>
			</div>
			<div class="right">
				<uploader ref="uploader" :options="options" :autoStart="false" @file-added="onFileAdded"
					@files-submitted="onSubmitted" v-if="!allUpLoadIng && !allisTurnIng && !allzhSuccessEnd"
					class="uploader-app el-button el-button--default el-popover__reference">
					<uploader-btn :attrs="attrs" ref="uploadBtn">添加文件</uploader-btn>
				</uploader>
				<el-tooltip v-if="!allzhSuccessEnd&&!isOnLine" effect="light" content="离线验证只能验证文档篡改和签名有效性，无法确认签发者的真实身份" placement="bottom">
					<el-button type="primary" key="autoButton"
					:disabled="allUpLoadIng || allisTurnIng || uploadSuccessList.length <= 0" @click="changeTurn(false)">{{
							allisTurnIng&&!isOnLine ? "验签中..." : "离线验签"
					}}</el-button>
				</el-tooltip>
				<el-tooltip v-if="!allzhSuccessEnd&&!isleaveLine" effect="light" content="在线验证除了验证文档篡改和签名有效性外还验证了证书链和吊销状态，确保签发者的身份真实可信" placement="bottom">
					<el-button type="primary" key="autoButton2"
					:disabled="allUpLoadIng || allisTurnIng || uploadSuccessList.length <= 0" @click="changeTurn(true)">{{
							allisTurnIng&&isOnLine ? "验签中..." : "在线验签"
					}}</el-button>
    			</el-tooltip>
				
				

				<el-button v-if="(!allUpLoadIng && !allisTurnIng && allzhSuccessEnd) || (allZhError && !allisTurnIng)"
					type="primary" @click="reLoadTurn">重新上传</el-button>
			</div>
		</div>
		<infoDialog :show.sync="signatureDialog" :seal-info-list.sync="sealInfoList" :overOnLine="overOnLine"
			:verify-result.sync="verifyResult" />
		<!-- 继续转换弹框 -->
		<el-dialog title="提示" :visible.sync="dialogTips" class="changephone_box agin_box" :close-on-click-modal="false"
			width="420px" append-to-body>
			<div class="content">重新上传将清空当前列表，请您先下载保存文档。是否重新上传文件？</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitTurn" size="mini">确 定</el-button>
				<el-button @click="dialogTips = false" size="mini">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import icon from "@comm/components/document-conversion/iconImg";
import infoDialog from "./infoDialog.vue";
import { getfilesize } from "@comm/utils/tools";
import { pubserviceUpload } from "@comm/api/document-conversion";
import { fileVerify, packZipDownload, downloadUploadFile, leavefileVerify } from "@comm/api/document-conversion/attestation.js";
import Files from "@comm/utils/files";
import { getUserInfo } from "@comm/utils/auth";
export default {
	name: "tableTurn",
	components: {
		icon,
		infoDialog
	},
	props: {
		fileListData: "",
		isShowData: false,
		attrsData: "",
		allUpLoadIngData: false,
		allzhSuccessEndData: false
	},
	data() {
		return {
			newFileList: this.fileListData,
			fileList: [],
			visible: false,
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { }
			},
			attrs: {
				accept: this.attrsData
			},
			interval: "",
			isMerge: false,
			allisTurnIng: false,
			dialogDownZip: false,
			downZipName: "",
			zhSuccessList: [],
			uploadSuccessList: [],
			allUpLoadIng: this.allUpLoadIngData,
			allzhSuccessEnd: this.allzhSuccessEndData,
			isShow: this.isShowData,
			isDelete: false,
			downzhSuccessList: [],
			downList: [],
			createSortable: "",
			fileNameReg: /.*[\\\/:*?"<>|]+.*/,
			isDown: false,
			addUpLad: false,
			allZhError: false,
			folderslname: "",
			isReUpload: "",
			dialogTips: false,
			transfering: false,
			transferList: [],
			transferListLng: 0,
			showBottom: true,
			signatureDialog: false,
			sealInfoList: [],
			verifyResult: [],
			activeChoose: 1,
			isOnLine:false,
			isleaveLine:false,
			overOnLine:false
		};
	},
	filters: {
		ellipsis(value) {
			if (!value) return "";
			let fileListArrayname = value;
			let fileNameSuffix1 = fileListArrayname;
			if (fileListArrayname.length > 15) {
				value = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
			}
			return value;
		}
	},
	watch: {
		attrsData(val) {
			this.attrs.accept = val;
		},
		isShowData(val) {
			this.isShow = val;
		},
		fileListData(val) {
			if (val.length > 0 && this.allUpLoadIng) {
				this.downzhSuccessList = [];
				this.downList = [];
			}

			this.newFileList = val;
			this.newFileList.forEach((item) => {
				item.getfilesize = getfilesize(item.size);
			});
			if (
				this.zhSuccessList.length > 0 ||
				(!this.isDelete && !this.addUpLad && this.uploadSuccessList.length <= 0 && this.zhSuccessList.length <= 0) ||
				(this.isDelete && !this.addUpLad) ||
				this.transfering ||
				this.isReUpload
			) {
				this.fileList = this.newFileList;

				// this.allzhSuccessEnd=false
			} else {
				this.fileList = [...this.fileList, ...this.newFileList];
			}
		},
		fileList(val) {
			if (!this.isShow) {
				return;
			}

			this.fileList = val;

			let uploadSuccessList = [];
			this.fileList.forEach((item, index) => {
				item.index = index;
				if (item.upLoadSuccess) {
					uploadSuccessList.push(item);
				}
			});
			this.uploadSuccessList = uploadSuccessList;
		},
		allUpLoadIngData(val) {
			this.allUpLoadIng = val;
			if (!val) {
				let uploadSuccessList = [];
				this.fileList.forEach((item, index) => {
					if (item.upLoadSuccess && !item.zhSuccess) {
						uploadSuccessList.push(item);
					} else if (item.zhSuccess) {
						this.allzhSuccessEnd = true;
						this.allisTurnIng = false;
					}
				});
				this.uploadSuccessList = uploadSuccessList;
				if (this.uploadSuccessList.length > 0) {
					this.zhSuccessList = [];
					this.allzhSuccessEnd = false;
				}
				if (this.newFileList.length <= 0 && this.zhSuccessList.length > 0) {
					this.allzhSuccessEnd = true;
				}
				if (this.newFileList.length <= 0 && this.zhSuccessList.length <= 0) {
					this.isDelete = false;
				}
			}
		},
		allzhSuccessEndData(val) {
			this.allzhSuccessEnd = val;
		},
		allzhSuccessEnd(val) {
			if (val) {
				// if (this.createSortable) {
				//   this.createSortable.option("disabled", true); // set
				// }
				this.$forceUpdate();
				let zhSuccessList = [];
				let downzhSuccessList = [];
				let downList = [];
				this.fileList.forEach((item, index) => {
					zhSuccessList.push(item);
					if (item.zhSuccess) {
						downzhSuccessList.push(item);
					}
					if (item.download) {
						downList.push(item);
					}
				});
				// this.uploadSuccessList = [];
				this.downzhSuccessList = downzhSuccessList;
				this.zhSuccessList = zhSuccessList;
				this.downList = downList;
			}
		},
		transferList(val) {
			if (val.length > 0 && this.allisTurnIng) {
				for (let index = 0; index < val.length; index++) {
					if (index <= 4) {
						this.getTransfer(index);
					}
				}
			}
		},
		transferListLng(val) {
			if (this.transferListLng + 5 <= this.transferList.length) {
				this.getTransfer(this.transferListLng + 4);
			}
		}
	},
	mounted() { },
	methods: {
		chooseClick(type) {
			this.activeChoose = type
			if (type == 1) {
				this.fileList = this.zhSuccessList
			} else if (type == 2) {
				if (this.downzhSuccessList <= 0) {
					this.chooseClick(1)
				} else {
					this.fileList = this.downzhSuccessList
				}

			} else {
				if (this.downzhSuccessList <= 0) {
					this.fileList = this.zhSuccessList
				} else {
					let list = this.zhSuccessList.filter(item1 => !this.downzhSuccessList.some(item2 => item2 === item1))
					if (list <= 0) {
						this.chooseClick(1)
					} else {
						this.fileList = list
					}
				}

			}
			let downList = [];
			this.fileList.forEach((item, index) => {
				if (item.download) {
					downList.push(item);
				}
			});
			this.downList = downList;
		},
		showItem(row) {
			const { signature, verify } = row;
			this.signatureDialog = true;
			this.sealInfoList = signature;
			let verifyResult = verify
			verifyResult.forEach((item, index) => {
				item.name = this.sealInfoList[index] ? (this.sealInfoList[index].type == 'Sign' || this.sealInfoList[index].type == 'TimeStamp' ? this.sealInfoList[index].signCert.subjectInfo.commonName : this.sealInfoList[index].sealName) : null;
				item.img = this.sealInfoList[index].type == 'Sign' ? require("@comm/images/document-conversion/electronic/qm_icon.png") : (this.sealInfoList[index].type == 'TimeStamp' ? require("@comm/images/document-conversion/electronic/time_stamp_icon.png") : "data:image/png;base64," + this.sealInfoList[index].sealImage.pictureData);
				item.type = this.sealInfoList[index].type
			});
			this.verifyResult = verifyResult
		},
		// 删除
		suspendBtn(file) {
			this.addUpLad = false;
			if (!this.allzhSuccessEnd) {
				const index = this.fileList.indexOf(file);
				this.fileList.splice(index, 1);
				if (this.fileList.length <= 0) {
					this.reLoadTurnReset()
					return
				}
				let data = {
					fileList: this.fileList,
					isShow: this.isShow,
					oldFileList: this.fileList,
				};
				this.isDelete = true;
				this.$emit("endTurn", data);
			} else if (this.allzhSuccessEnd) {
				const index = this.zhSuccessList.indexOf(file);
				this.zhSuccessList.splice(index, 1);
				if (this.zhSuccessList.length <= 0) {
					this.reLoadTurnReset()
					return
				}
				let downzhSuccessList = [];
				this.zhSuccessList.forEach((item, index) => {
					if (item.zhSuccess) {
						downzhSuccessList.push(item);
					}
				});
				this.downzhSuccessList = downzhSuccessList;
				this.chooseClick(this.activeChoose)
				let data = {
					fileList: this.fileList,
					isShow: this.isShow,
					oldFileList: this.fileList,
				};
				this.isDelete = true;
				this.$emit("endTurn", data);
			}
		},
		//打包下载
		downZip() {
			if (this.isDown) {
				return;
			}
			this.isDown = true;
			let sizeTotal = 0;
			this.fileList.forEach((item) => {
				sizeTotal += +item.size;
			});
			let list = [];
			this.fileList.forEach((item) => {
				if (item.download) {
					list.push(item.fileConversionNeedDTO.fileId);
				}
			});
			packZipDownload(
				{
					list
				},
				false,
				true
			)
				.then((res) => {
					this.dialogDownZip = false;
					this.downloadFile(1, res, sizeTotal);
				})
				.catch((err) => {
					this.isDown = false;
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
				});
		},
		// 下载
		downdBtn(file) {
			if (file.isDowning) return;
			file.isDowning = true;
			this.fileList.map((item, index) => {
				if (item.fileConversionNeedDTO.fileId == file.fileConversionNeedDTO.fileId) {
					this.$set(this.fileList, index, file);
				}

			});
			let data = {}
			data = {
				fileId: file.fileConversionNeedDTO.fileId,
			}
			downloadUploadFile(data)
				.then((res) => {
					this.downloadFile(2, res, file);
				})
				.catch((err) => {
					file.isDowning = false;
					this.fileList.map((item, index) => {
						if (item.fileConversionNeedDTO.fileId == file.fileConversionNeedDTO.fileId) {
							this.$set(this.fileList, index, file);
						}
					});
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
				});
		},
		downloadFile(type, res, file) {
			let that = this;
			Files.downloadFile(type, res, file, (type, file) => {
				this.isDown = false;
				if (type == 2) {
					file.isDowning = false;
					this.$set(this.fileList, file.index, file);
				}
				that.$forceUpdate();
			});
		},
		// 预览
		readApi(shortUrl) {
			if (!this.allzhSuccessEnd) return
			let userInfo = JSON.parse(getUserInfo())
			let nickname = encodeURIComponent(encodeURIComponent(userInfo.nickname))
			const { href } = this.$router.resolve({
				path: `/r:${shortUrl}&&${nickname}`
			});
			window.open(href, "_blank");
		},
		reLoadTurn() {
			let list = [];
			this.fileList.forEach((item) => {
				if (item.download) {
					list.push(item);
				}
			});
			if (list.length > 0) this.dialogTips = true;
			else this.reLoadTurnReset();
		},
		submitTurn() {
			this.reLoadTurnReset();
		},
		reLoadTurnReset() {
			this.transferListLng = 0;
			this.transferList = [];
			this.isReUpload = "";
			this.isDelete = false;
			this.transfering = false;
			this.addUpLad = false;
			this.uploadSuccessList = [];
			this.zhSuccessList = [];
			this.fileList = [];
			this.dialogTips = false;
			this.activeChoose = 1
			this.isShow = false;
			this.isAllDel = false;
			this.allzhSuccessEnd = false;
			this.allZhError = false;
			let data = {
				fileList: [],
				isShow: false,
				oldFileList: [],
				isAllDel: false,
			};
			this.$emit("endTurn", data);
		},
		// 清空列表
		submitBtn() {
			this.transferListLng = 0;
			this.transferList = [];
			this.isReUpload = "";
			this.isDelete = false;
			this.transfering = false;
			this.dialogTips = false;
			this.fileList = [];
			this.uploadSuccessList = [];
			this.zhSuccessList = [];
			this.downzhSuccessList = [];
			this.allUpLoadIng = false;
			this.allisTurnIng = false;
			this.allzhSuccessEnd = false;
			this.allZhError = false;
			this.activeChoose = 1
			this.addUpLad = false;
			this.visible = false;
			this.newFileList = [];
			let data = {
				fileList: this.fileList,
				isShow: false,
				oldFileList: this.fileList,
				isAllDel: true,
			};
			this.$emit("endTurn", data);
		},
		// 上传
		onFileAdded(file, isReUpload) {
			this.isReUpload = isReUpload;
			this.newFileList = [];

			this.fileList.forEach((item, index) => {
				item.index = index;
			});

			if (isReUpload) {
				file.isReUpload = true;
				file.cause = "";
				file.isUpLoading = true;
				file.wait = false;
			}
			this.$parent.onFileAdded(file, isReUpload, this.fileList);
		},
		onSubmitted(fileList) {
			if (fileList.length <= 0) {
				return;
			}
			this.addUpLad = true;
			this.isDelete = false;
			this.allZhError = false;

			this.downzhSuccessList = [];
			// this.uploadSuccessList=[]
			this.allisTurnIng = false;
			// this.isDelete = false;
			this.allzhSuccessEnd = false;
			let data = {
				fileList: this.fileList,
				allzhSuccessEnd: this.allzhSuccessEnd
			};

			this.$emit("AddUpload", data);
			this.$parent.onSubmitted(fileList);
		},
		//验证
		changeTurn(onLine) {
			this.isOnLine = onLine;
			this.isleaveLine = !onLine
			if (this.allUpLoadIng || this.allisTurnIng || this.allzhSuccessEnd) {
				return;
			}
			this.allzhSuccessEnd = false;
			this.submitFolder();
		},
		submitFolder() {
			this.allisTurnIng = true;
			this.transfering = true;

			this.$forceUpdate();
			this.allzhSuccessEnd = false;

			this.fileList.forEach((item) => {
				this.transferList.push(item);
			});
		},
		getTransfer(i) {
			if (this.transferList[i].cause) {
				this.transferListLng = this.transferListLng + 1;
				if (this.transferListLng == this.transferList.length) {
					this.allisTurnIng = false;
					this.allzhSuccessEnd = true;
					this.isOnLine = false;
					this.isleaveLine = false;
					return;
				}
				return;
			} else {
				this.fileList[i].isTurnIng = true;
			}


			let obj = this.fileList[i];
			let parmers = ""
			if(this.isOnLine){
				this.overOnLine = false
				parmers = fileVerify({ fileId: this.fileList[i].fileConversionNeedDTO.fileId,verify:this.isOnLine })
			}else{
				this.overOnLine = true
				parmers = leavefileVerify({ fileId: this.fileList[i].fileConversionNeedDTO.fileId })
			}
			parmers.then((res) => {
					obj.isTurnIng = false;
					obj.isDowning = false;
					this.$set(this.fileList, i, obj);
					if (res.code === 110001) {
						this.fileList[i].cause = '验证未知'
						this.fileList[i].zhError = true;
						this.fileList[i].sxShow = false;
						this.fileList[i].open = false
						this.fileList[i].download = false;
						this.fileList[i].djgShow = false
						this.fileList[i].noopen = true
					} else {
						this.fileList[i].signature = this.isOnLine?res.data.SignatureAndCertChains:res.data.signature;
						this.fileList[i].verify = res.data.verify;
						this.fileList[i].download = res.data.download;
						let wzList = []
						let sxList = []
						let yxList = []
						if (this.fileList[i].verify.length <= 0) {
							this.fileList[i].cause = '验证未知'
							this.fileList[i].zhError = true;
							this.fileList[i].sxShow = false;
							this.fileList[i].open = false
							this.fileList[i].djgShow = false
							this.fileList[i].noopen = true
						} else {
							this.fileList[i].verify.forEach((item, index) => {
								if (item.code == 0 || (item.code >= '0X00000900' && item.code <= '0X000009FF')) {
									yxList.push(item)
								} else if (item.code == '0X00000100' || item.code == '-1' || item.code == '-2' || item.code == '-15') {
									wzList.push(item)
								} else {
									sxList.push(item)
								}
							})

							if (yxList.length == this.fileList[i].verify.length) {
								this.fileList[i].cause = ''
								this.fileList[i].zhSuccess = true;
								this.fileList[i].sxShow = false;
								this.fileList[i].open = true
								this.fileList[i].djgShow = false;
								this.fileList[i].noopen = false
							} else if (sxList.length == this.fileList[i].verify.length) {
								this.fileList[i].cause = '验证无效'
								this.fileList[i].zhError = true;
								this.fileList[i].sxShow = true;
								this.fileList[i].open = true
								this.fileList[i].noopen = false
								this.fileList[i].djgShow = false;
							} else if (yxList.length <= 0 && wzList.length > 0) {
								this.fileList[i].cause = '验证未知'
								this.fileList[i].zhError = true;
								this.fileList[i].sxShow = false;
								this.fileList[i].open = true
								this.fileList[i].noopen = false
								this.fileList[i].djgShow = false;
							} else {
								this.fileList[i].cause = `验证${yxList.length > 0 ? `有效${yxList.length}、` : ''}${sxList.length > 0 ? `无效${sxList.length}` : ''}${sxList.length > 0 && wzList.length > 0 ? `、` : ''}${wzList.length > 0 ? `未知${wzList.length}` : ''}`
								this.fileList[i].zhError = true;
								this.fileList[i].sxShow = false;
								this.fileList[i].open = true
								this.fileList[i].noopen = false
								this.fileList[i].djgShow = true;
							}
						}
					}
					this.getpubserviceUpload(this.fileList[i], i)
				})
				.catch((err) => {
					this.transferListLng = this.transferListLng + 1;
					obj.zhError = true;
					obj.isTurnIng = false;
					obj.cause = '验证未知'
					obj.sxShow = false;
					obj.djgShow = false;
					obj.open = false
					obj.noopen = true
					this.$set(this.fileList, i, obj);
					if (this.transferListLng == this.transferList.length) {
						this.showBottom = true;
						this.allisTurnIng = false;
						this.allzhSuccessEnd = true;
						this.allZhError = true;
						this.isOnLine = false;
						this.isleaveLine = false;
						return;
					}
				});
		},
		getpubserviceUpload(file, index) {
			pubserviceUpload({
				fileName: file.fileConversionNeedDTO.fileName,
				fileUrl: file.fileConversionNeedDTO.filePath,
				fileType: file.fileType,
				fileSize: file.fileConversionNeedDTO.fileSize,
				fileId: file.fileConversionNeedDTO.fileId,
				zipPassword: '' //解压密码
			})
				.then((res) => {
					let data = res.data.data;
					if (data) {
						this.fileList[index].shortUrl = data.shortUrl
						this.transferListLng = this.transferListLng + 1;
						if (this.transferListLng == this.transferList.length) {
							this.allisTurnIng = false;
							this.allzhSuccessEnd = true;
							this.isOnLine = false;
							this.isleaveLine = false;
						}
					}
				})
				.catch((err) => {

				});
		},
	}
};
</script>
<style lang="scss">
.el-table__body {
	width: 100% !important;
}

.el-table td {
	padding: 0 !important;
	height: 55px;
}

.table_box .el-table td,
.table_box .el-table th.is-leaf {
	border: none !important;
}
.table_tuen_box th.el-table__cell{
			background: transparent!important;
		}
.el-table thead th,
.el-table thead tr {
	background: #f5f7f9;
}

.el-table thead th {
	padding: 0 !important;
	height: 46px;
	font-size: 16px;
	color: #36425a;
	font-weight: normal;
	line-height: 22px;

	.cell span {
		font-size: 16px;
	}
}

.el-table th>.cell {
	padding-left: 4px !important;
}

.el-table::before {
	display: none;
}

.el-table__body-wrapper {
	box-sizing: border-box;
}

.el-table__body {
	table-layout: inherit;
}

.el-table--enable-row-transition .el-table__body td:first-child>.cell {
	padding-left: 30px;
}

.el-table th:first-child>.cell,
.el-table td:first-child>.cell {
	padding-left: 32px !important;

	.tips {
		font-size: 12px;
		color: #8b97af;
		line-height: 22px;
		margin-left: 12px;
	}
}

.el-table th:last-child>.cell {
	padding-right: 32px;
}

.el-table thead .el-table tr {
	padding: 0 32px;
}

.el-popover {
	padding: 20px;
}

.el-table .cell {
	font-size: 14px;
	line-height: 22px !important;
	padding: 0 !important;

	.fonts {
		display: inline-block;
		width: 92%;
		vertical-align: middle;

		a {
			color: #242F44;
		}

		&.active {
			cursor: pointer;

			&:hover {
				a {
					color: #14A8F0;
				}
			}
		}
	}
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.isMerge_btn {
	width: auto;
	height: 40px;
	background: #FFFFFF !important;
	border-radius: 2px !important;
	border: 1px solid #14A8F0 !important;
	padding: 0 9px !important;
	line-height: 40px !important;
	color: #14A8F0 !important;

	&:hover,
	&:active {
		background: #14A8F0 !important;
		color: #fff !important;

	}
}

.retry_icon {
	font-size: 14px;
	color: #14a8f0;
	line-height: 22px;
	text-decoration: underline;
	padding-left: 23px;
	cursor: pointer;
}

.el-button:hover,
.el-button--default:focus,
.el-button:active {
	background: none;
	border: 1px solid #dcdfe6;
	color: #606266;
}

.changephone_box {
	.content {
		.el-input {
			width: 80%;
		}
	}

	&.agin_box {
		.el-dialog__body {
			padding: 0 24px 64px;
		}
	}
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
	color: #c0c4cc;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
	color: #fff;
	background-color: #a0cfff;
	border-color: #a0cfff;
}

.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
	background-color: #14a8f0;
	border-color: #14a8f0;
	color: #fff;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
	color: #c0c4cc !important;
}

.hidea {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: block;
}

.no_list {
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 16px;
	color: #242f44;
	line-height: 22px;
	height: 323px;
	justify-content: center;

	.turn_box {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 24px;
	}

	img {
		width: 64px;
		height: 64px;
		margin-right: 12px;
	}
}

.table_box {
	height: 100%;

	.turn_ing {
		font-size: 16px;
		color: #6d7278;
		line-height: 22px;
	}

	.uploader {
		width: auto;
		padding: 0 !important;
		border: none !important;
	}

	.downZip {
		margin-left: 28px;
		width: 116px;

		&:hover {
			cursor: pointer;
			color: #15b2ff;
		}

		&:focus,
		&:active {
			color: #1299d9;
		}

		&.disable {
			color: #c0c4cc;
			position: relative;
		}
	}

	.uploader-btn {
		margin: 0;
		padding: 8px 19px;
		line-height: 22px;
		border: 1px solid #d7d9de;
		color: #36425a;
		border-radius: 2px;
		font-weight: normal;

		&:hover {
			background: none !important;
			border: 1px solid #15b2ff !important;
			color: #15b2ff !important;
		}
	}

	.el-table {
		height: 323px;
		overflow-y: auto;
		th.el-table__cell{
			background: transparent;
		}
	}

	.table_bottom {
		height: 88px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 32px;
		border-top: 1px #f3f4f5 solid;

		.left {
			.hb_box {
				display: inline-block;
				font-size: 14px;
				color: #4f5d79;
				line-height: 22px;
				margin-left: 24px;

				&.disable {
					color: #c0c4cc;
				}

				&.list_box {
					margin-left: 0;

					&>span {
						cursor: pointer;
					}

					.list_item1:hover,
					.active1 {
						color: #14A8F0;
					}

					.list_item2:hover,
					.active2 {
						color: #3FC857;
					}

					.list_item3:hover,
					.active3 {
						color: #FFAA00;
					}
				}
			}
		}
	}
}

.el-table td>span {
	display: inline-block;
	width: 24px;
}

.el-table td div.fonts {
	display: inline-block;

	a {
		font-size: 14px;
		color: #242f44;
		line-height: 22px;

		&:hover {
			color: #242f44;
			text-decoration: none;
		}
	}
}

.el-table td div.el-progress {
	width: 70%;
}

.fail_box {
	text-align: left;
	margin-top: 66px;

	a {
		padding-left: 12px;
		font-size: 16px;
		color: #242f44;
		line-height: 22px;
	}
}

.cs_button_box {
	text-align: left;
	margin-top: 32px;

	span {
		font-size: 14px;
		color: #36425a;
		line-height: 22px;
		width: 64px;
		display: inline-block;
		text-align: center;
		margin-right: 28px;
	}
}

.delet_icon {
	vertical-align: middle;
}

.yq_icon {
	margin: 0;
	display: inline-block;
    width: 20px;
    height: 20px;
	vertical-align: middle;
	background: url(../../../../comm/images/document-conversion/onlinePreview/yq_icon.png) 0 0 no-repeat;
	background-size: 100% 100%;
	&:hover,&:focus{
		background: url(../../../../comm/images/document-conversion/onlinePreview/yq_icon_active.png) 0 0 no-repeat;
	background-size: 100% 100%;
	cursor: pointer;
	}
	&.disable{
		visibility: hidden;
	}
}

.open_icon {
	margin: 0 24px;
}

.yz_success_icon,
.sx_error,
.djg_error,
.noopen_error,
.wz_error {
	width: 16px;
	height: 16px;
	margin-right: 8px;
}

.yz_success_icon {
	background: url("../../../../comm/images/document-conversion/electronic/success.png") 0 0 no-repeat;
	background-size: 100% 100%;
}

.sx_error {
	background: url("../../../../comm/images/document-conversion/electronic/sx_icon.png") 0 0 no-repeat;
	background-size: 100% 100%;
}
.djg_error {
	background: url("../../../../comm/images/document-conversion/onlinePreview/djg_icon.png") 0 0 no-repeat;
	background-size: 100% 100%;
}
.noopen_error{
	background: url("../../../../comm/images/document-conversion/electronic/wz_noopen_icon.png") 0 0 no-repeat;
	background-size: 100% 100%;
}

.wz_error {
	background: url("../../../../comm/images/document-conversion/electronic/wz_icon.png") 0 0 no-repeat;
	background-size: 100% 100%;
}

// .open_icon.disable, .down_icon.disable{
// 	visibility: inherit;
// }
</style>



// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/attestationPage/components/tableTurn.vue